export const SUPER_ADMIN = 'SUPER_ADMIN';
export const SUB_ADMIN = 'SUB_ADMIN';
export const INTERVIEWER = 'INTERVIEWER';
export const EMPLOYER_SUPER_ADMIN = 'EMPLOYER_SUPER_ADMIN';
export const EMPLOYER_SUB_ADMIN = 'EMPLOYER_SUB_ADMIN';
